module.exports = __webpack_public_path__ + "img/icon_02.6247e27.png";